import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import { translations } from '../locales/translations';
import './Footer.css';

function Footer() {
  const { language } = useContext(LanguageContext);
  const t = translations[language].footer;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/" className="footer-link">{t.home}</Link>
            <Link to="/support" className="footer-link">{t.support}</Link>
            <Link to="/privacy" className="footer-link">{t.privacy}</Link>
          </div>
          <div className="footer-copyright">
            {t.copyright}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
